/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gatekeeper_ControlsInputs */

const en_gatekeeper_controls = /** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatekeeper Controls`)
};

const id_gatekeeper_controls = /** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrol Penjaga Gerbang`)
};

/** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */
const es_gatekeeper_controls = en_gatekeeper_controls;

/** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */
const fr_gatekeeper_controls = en_gatekeeper_controls;

/** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */
const de_gatekeeper_controls = en_gatekeeper_controls;

/** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */
const ja_gatekeeper_controls = en_gatekeeper_controls;

/** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */
const zh_gatekeeper_controls = en_gatekeeper_controls;

/** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */
const ar_gatekeeper_controls = en_gatekeeper_controls;

/** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */
const it_gatekeeper_controls = en_gatekeeper_controls;

/** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */
const ru_gatekeeper_controls = en_gatekeeper_controls;

/** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */
const pt_gatekeeper_controls = en_gatekeeper_controls;

/** @type {(inputs: Gatekeeper_ControlsInputs) => LocalizedString} */
const ko_gatekeeper_controls = en_gatekeeper_controls;

/**
* | output |
* | --- |
* | "Gatekeeper Controls" |
*
* @param {Gatekeeper_ControlsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gatekeeper_controls = /** @type {((inputs?: Gatekeeper_ControlsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gatekeeper_ControlsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gatekeeper_controls(inputs)
	if (locale === "es") return es_gatekeeper_controls(inputs)
	if (locale === "fr") return fr_gatekeeper_controls(inputs)
	if (locale === "de") return de_gatekeeper_controls(inputs)
	if (locale === "ja") return ja_gatekeeper_controls(inputs)
	if (locale === "zh") return zh_gatekeeper_controls(inputs)
	if (locale === "ar") return ar_gatekeeper_controls(inputs)
	if (locale === "id") return id_gatekeeper_controls(inputs)
	if (locale === "it") return it_gatekeeper_controls(inputs)
	if (locale === "ru") return ru_gatekeeper_controls(inputs)
	if (locale === "pt") return pt_gatekeeper_controls(inputs)
	return ko_gatekeeper_controls(inputs)
});